module.exports = __webpack_public_path__ + "img/restaurant_bodyimage09.1c6a5d1a.jpg";